var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 10.625L13.5731 13.7044C13.8299 13.8823 14.1701 13.8823 14.4269 13.7044L18.875 10.625M9.5 18.5H18.5C19.3284 18.5 20 17.8284 20 17V11C20 10.1716 19.3284 9.5 18.5 9.5H9.5C8.67157 9.5 8 10.1716 8 11V17C8 17.8284 8.67157 18.5 9.5 18.5Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCircle);
export default __webpack_public_path__ + "static/media/email-circle.9c8315f8417ac6636164d133acc2004f.svg";
export { ForwardRef as ReactComponent };